import factoryAbi from "./Factory.json";

export const FactoryAbi = factoryAbi;
